<section class="target">
  <h2 class="target__title">
    <img [src]="icon() === 'warning' ? '/assets/warning.svg' : '/assets/crosshair.svg'" alt="" />
    {{ heading() }}
  </h2>
  @if (portrait()) {
    <img class="portrait" src="/assets/silhouette.svg" alt="" />
  }
  <div class="target__body">
    @if (name(); as name) {
      <div>
        <p class="label">{{ nameLabel() }}</p>
        <p class="target__name">{{ name }}</p>
        @if (aside(); as aside) {
          <p class="target__aside">{{ aside }}</p>
        }
      </div>
    }
    @if (action(); as action) {
      <div>
        <p class="label">{{ actionLabel() }}</p>
        <p class="action">
          <span class="bubble" aria-hidden="true">« … »</span>
          <span class="action__text">{{ action }}</span>
        </p>
      </div>
    }
    <ng-content />
  </div>
  @if (stamp(); as stamp) {
    <p class="stamp stamp--round stamp--pinned" aria-hidden="true">{{ stamp }}</p>
  }
</section>
